// Shows character/item count vs max allowed
// Figma: simple "0/100" text, no progress bar
interface CharacterCounterProps {
  count: number;
  maxLength: number;
}

export function CharacterCounter({ count, maxLength }: CharacterCounterProps) {
  const percentage = (count / maxLength) * 100;

  // Color changes when approaching/exceeding limit
  let colorClass = 'text-gray-400';
  if (percentage >= 100) {
    colorClass = 'text-red-500';
  } else if (percentage >= 90) {
    colorClass = 'text-amber-500';
  }

  return (
    <span className={`text-xs ${colorClass}`}>
      {count}/{maxLength}
    </span>
  );
}
